// extracted by mini-css-extract-plugin
export default {"container":"thanks_container__ozQ6l","header":"thanks_header__YW+l6","message":"thanks_message__mvJKg","note":"thanks_note__lWxN3"};